<div class="store-selection-dialog-wrapper">
  <h2 mat-dialog-title>Store Selection</h2>
  <mat-tab-group [(selectedIndex)]="tabIndex">
    <mat-tab label="All"></mat-tab>
    <mat-tab label="Sushi"></mat-tab>
    <mat-tab label="Bento"></mat-tab>
  </mat-tab-group>
  <div class="search-row">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Search.." [(ngModel)]="searchText">
    </mat-form-field>
  </div>
  <div class="select-row">
    <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isIndeterminate()" (change)="toggleAll()">
      Select All / None
    </mat-checkbox>
    <mat-checkbox [checked]="selectedOnly" (change)="selectedOnly = $event.checked">Selected Only</mat-checkbox>
  </div>
  <div class="store-list">
    <div class="store-item" *ngFor="let store of currentStores" [ngClass]="{'selected': selectedStoreIds.has(store.id)}">
      <mat-checkbox
        [checked]="selectedStoreIds.has(store.id)"
        (change)="toggleStore(store)"
        
      ></mat-checkbox>
      <span>{{ store.name }}</span>
      <span class="tick-container" *ngIf="selectedStoreIds.has(store.id)"><mat-icon color="primary">check</mat-icon></span>
    </div>
  </div>
  <div class="bottom-row">
    <mat-checkbox [(ngModel)]="includeSameStoreLY" (change)="onIncludeSameStoreLYChange($event.checked)">Include only same store LY</mat-checkbox>
  </div>
  <div class="dialog-actions">
    <button mat-raised-button color="primary" (click)="onApply()">Apply</button>
    <button mat-button (click)="onCancel()">Cancel</button>
  </div>
</div>

